import { tolgee } from '@/tolgee/client';
/**
 * 全局 Toast 翻译工具
 *
 * 优雅现代精简的解决方案，支持：
 * - 自动翻译 tolgee key
 * - 客户端/服务端统一接口
 * - 零冗余代码
 */
import { toast as hotToast } from 'react-hot-toast';

/**
 * 获取翻译文本的工具函数
 */
const getTranslation = (key: string): string => {
  if (typeof window === 'undefined') {
    // 服务端直接返回 key
    return key;
  }

  try {
    // 客户端使用 tolgee 翻译
    return tolgee.t(key) || key;
  } catch {
    // 翻译失败时返回原 key
    return key;
  }
};

/**
 * 全局 Toast 工具 - 自动翻译版本
 */
export const toast = {
  /**
   * 显示成功 toast（自动翻译）
   */
  success: (tolgeeKey: string) => {
    return hotToast.success(getTranslation(tolgeeKey));
  },

  /**
   * 显示错误 toast（自动翻译）
   */
  error: (tolgeeKey: string) => {
    return hotToast.error(getTranslation(tolgeeKey));
  },

  /**
   * 显示信息 toast（自动翻译）
   */
  info: (tolgeeKey: string) => {
    return hotToast(getTranslation(tolgeeKey));
  },

  /**
   * 显示警告 toast（自动翻译）
   */
  warning: (tolgeeKey: string) => {
    return hotToast(getTranslation(tolgeeKey));
  },

  /**
   * 立即关闭 toast
   */
  dismiss: (id?: string) => {
    hotToast.dismiss(id);
  },

  /**
   * 立即移除 toast
   */
  remove: (id?: string) => {
    hotToast.remove(id);
  },
};
